import clsx from 'clsx';
import { ReactNode } from 'react';
import styles from './button.module.scss';

type ButtonSetProps = {
  children: ReactNode;
  direction?: 'horizontal' | 'vertical';
  spacing?: 'small' | 'medium';
  justify?: 'start' | 'end' | 'center' | 'space-between';
  /**
   * When true, buttons are stacked vertically in small containers
   * and horizontally on larger containers
   */
  responsive?: boolean;
  className?: string;
};

/**
 * ButtonSet - Group buttons with flexible layout options
 *
 * Set `responsive={true}` to automatically stack buttons in small containers
 * and display them in a row on larger containers
 */
export const ButtonSet = ({
  children,
  direction = 'horizontal',
  spacing = 'medium',
  justify = 'start',
  responsive = false,
  className,
}: ButtonSetProps) => {
  const buttonSet = (
    <div
      className={clsx(styles.buttonSet, className)}
      data-direction={responsive ? undefined : direction}
      data-responsive={responsive || undefined}
      data-spacing={spacing}
      data-justify={justify}
    >
      {children}
    </div>
  );

  return responsive ? (
    // If responsive, wrap with a container div that establishes the container query context
    <div className={styles.buttonSetContainer}>{buttonSet}</div>
  ) : (
    buttonSet
  );
};
